export const iconFontAwesomeBuildingsIgloo = (
	<i className="fa-solid fa-igloo"></i>
);
